<template>
    <div class="setting-style-width d-flex flex-column justify-content-center">
        <div class="w-100 pb-2 d-flex align-items-center">
            <label
                for="styleFontWeight"
                class="font-14 m-0"
            >
                Espessura da Fonte
            </label>

            <div class="ml-3 d-flex justify-content-center align-items-center">
                <button id="deslock" v-if="isLockStyleFontWeight" @click="handlerUnlockStyleFontWeight">
                    <i class="fal fa-lock font-14"></i>
                </button>

                <button id="lock" v-else @click="handlerLockStyleFontWeight">
                    <i class="fal fa-lock-open font-14"></i>
                </button>
            </div>
        </div>

        <div class="row no-gutters">
            <select
                id="styleFontWeight"
                name="styleFontWeight"
                class="col-12"
                style="color: #495057;"
                v-model="styleFontWeight"
                :disabled="isLockStyleFontWeight"
            >
                <option
                    v-for="weight in weights"
                    :key="weight.id"
                    :value="weight.value"
                >
                    {{ weight.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameStyleFontWeight',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            styleFontWeight: 0,
            weights: [
                { id: 1, name: "Thin", value: 100 },
                { id: 2, name: "ExtraLight", value: 200 },
                { id: 3, name: "Light", value: 300 },
                { id: 4, name: "Regular", value: 400 },
                { id: 5, name: "Medium", value: 500 },
                { id: 6, name: "SemiBold", value: 600 },
                { id: 7, name: "Bold", value: 700 },
                { id: 8, name: "ExtraBold", value: 800 },
                { id: 9, name: "Black", value: 900 },
            ],
        }
    },
    methods: {
        handlerLockStyleFontWeight() {
            this.$emit('onChangeStyleFontWeightLock', true);
        },
        handlerUnlockStyleFontWeight() {
            this.$emit('onChangeStyleFontWeightLock', false);
        },
    },
    computed: {
        isLockStyleFontWeight() {
            return !!this.item.extra.style_font_weight_lock;
        },
    },
    watch: {
        styleFontWeight() {
            this.$emit('onChangeStyleFontWeight', this.styleFontWeight);
        },
    },
    created() {
        this.styleFontWeight = this.item.extra.style.fontWeight ? this.item.extra.style.fontWeight : 500;
    },
}
</script>

<style scoped>
/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 15rem;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -12px; /* Centers thumb on the track */

   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
   border-radius: 50%;
}

input[type="range"]:focus::-webkit-slider-thumb {   
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
}

input[type="range"]:focus::-moz-range-thumb {
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}


#deslock, #lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameStyleFontWeight.vue